import { fg } from '@atlassian/jira-feature-gating';

const IssueTableDateRangeFieldRelayProvider = {
	get(): boolean {
		return fg('issue_table_date_range_field');
	},
};

export default IssueTableDateRangeFieldRelayProvider;
